// extracted by mini-css-extract-plugin
export default {"ads":"TvenDNXFUsxeXmjjKUbq"};